const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Shares Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Shares', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/learn/v3/shares/:subresource', null, {
      find: {params: {subresource: ''}, method: 'GET', isArray: true},
      findOne: {params: {subresource: ''}, method: 'GET', isArray: false},
      create: {params: {subresource: ''}, method: 'POST', isArray: false}
    });
  }]);
